export default "__VITE_ASSET__CMUbnPR7__"